import {
  IsArray,
  IsNotEmpty,
  IsIn,
  IsOptional,
  IsNumber,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

import { Constants } from "@eagerdog/constants";

import { IScentworkFault, IScentworkScore } from "./scentwork-score.interface";

// ------------
export class ScentworkFaultDto implements IScentworkFault {
  @IsNotEmpty()
  @IsIn(Object.values(Constants.scentwork_fault_type))
  fault_type: string;

  @IsNumber()
  fault_count: number;
}

// ---------------
export class ScentworkScoreDto implements IScentworkScore {
  @IsOptional()
  time_limit?: string;

  @IsOptional()
  @IsNumber()
  num_hides?: number;

  @IsOptional()
  @IsNumber()
  num_finds?: number;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ScentworkFaultDto)
  faults: ScentworkFaultDto[];

  /**
   * Constants.score_result_type:
   * Qualified
   * NQ
   * Excused
   */
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsOptional()
  result_reason?: string;

  @IsOptional()
  result_other_text?: string;

  @IsOptional()
  search_time?: string; //mm:ss:tt. Only if result_type == Constants.score_result_type.qualified
}
